import createNestedObject from './createNestedObject';

/**
 *
 * @param {Object} payload The payload to be copied and have special slugs replaced
 * @param {Object} eventData The current events eventData
 *
 * Copy the payload object and replace any special slugs: {{xxxxxx}}
 *
 * Special slugs:
 * {{UNDEFINED}} - Preserves undefined in the payload
 * {{REMOVEKEY}} - Removes the key from the payload
 * {{EMPTYSTRING}} - Will set value to empty string if special slug is toggled
 * {{EMPTYOBJECT}} - Will set value to empty object if special slug is toggled
 */
const copyPayload = (payload) => {
	const propertiesThatShouldBeUndefined = [];
	const propertiesThatShouldBeNull = [];

	const payloadCopy = JSON.parse(JSON.stringify(payload), (_key, value) => {
		let newValue = value;

		if (value?.includes?.('{{UNDEFINED|')) {
			propertiesThatShouldBeUndefined.push(
				value.split('|')[1].split('}}')[0]
			);
		} else if (value?.includes?.('{{NULL|')) {
			propertiesThatShouldBeNull.push(value.split('|')[1].split('}}')[0]);
		} else if (value?.includes?.('{{REMOVEKEY}}')) {
			newValue = undefined;
		} else if (value?.includes?.('{{EMPTYSTRING}}')) {
			newValue = '';
		} else if (value?.includes?.('{{EMPTYOBJECT}}')) {
			newValue = {};
		}

		return newValue;
	});

	propertiesThatShouldBeUndefined.forEach((propertyThatShouldBeUndefined) => {
		createNestedObject(payloadCopy, propertyThatShouldBeUndefined);
	});

	propertiesThatShouldBeNull.forEach((propertyThatShouldBeNull) => {
		createNestedObject(payloadCopy, propertyThatShouldBeNull, null);
	});
	return payloadCopy;
};

export default copyPayload;
